import { useMemo } from 'react';
import { MenuItem } from '@mui/material';

import { SelectFormField } from 'types';
import { defaultLanguage } from 'context';
import { useCourseContext } from 'context';

import { InputField } from '../fields';

export const FormSelectField = ({
  id,
  label,
  options,
  placeholder,
  translations,
}: SelectFormField) => {
  const { language } = useCourseContext();

  const translation = useMemo(() => {
    if (!language || !translations || language === defaultLanguage) {
      return {
        label,
        placeholder,
        options: options?.options
          ? options?.options.map((value) => ({ value, label: value }))
          : [],
      };
    }

    const translation = translations[language];
    const langOptions = translation.options || options?.options;
    return {
      label: label ? translation?.label || label : label,
      placeholder: translation?.placeholder || placeholder,
      options: langOptions
        ? langOptions.map((value, index) => ({
            label: value,
            value: options?.options?.[index] || value,
          }))
        : [],
    };
  }, [label, placeholder, options?.options, language, translations]);

  return (
    <InputField
      select
      name={id}
      fullWidth
      className="selectInput"
      label={translation.label}
      placeholder={translation.placeholder}
      slotProps={{
        select: {
          multiple: options?.multiple,
        },
      }}
    >
      {translation.options &&
        translation.options.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
    </InputField>
  );
};
